const standardLabelConfig: { [key: string]: string } = {
  address_lines: 'widget.address_form.ADDRESS_LINES_PLACEHOLDER',
  apartment_number: 'widget.address_form.APARTMENT_NUMBER_PLACEHOLDER',
  city: 'widget.address_form.CITY_PLACEHOLDER',
  email: 'widget.address_form.EMAIL_PLACEHOLDER',
  name: 'widget.address_form.NAME_PLACEHOLDER',
  first_name: 'widget.address_form.FIRST_NAME_PLACEHOLDER',
  last_name: 'widget.address_form.LAST_NAME_PLACEHOLDER',
  phone_number: 'widget.address_form.PHONE_NUMBER_PLACEHOLDER',
  postal_code: 'widget.address_form.POSTAL_CODE_PLACEHOLDER',
  region: 'widget.address_form.REGION_PLACEHOLDER',
  street: 'widget.address_form.STREET_PLACEHOLDER',
  street_number: 'widget.address_form.STREET_NUMBER_PLACEHOLDER',
  vat: 'widget.address_form.VAT_PLACEHOLDER',
  company_name: 'widget.address_form.COMPANY_NAME_PLACEHOLDER',
  care_of: 'widget.address_form.CARE_OF_PLACEHOLDER',
  floor_number: 'widget.address_form.FLOOR_PLACEHOLDER',
  national_id_number: 'widget.address_form.NATIONAL_ID_PLACEHOLDER',
  subregion: 'widget.address_form.SUBREGION_PLACEHOLDER',
  customs_number: 'widget.address_form.CUSTOMS_NUMBER_PLACEHOLDER',
};

export function getStandardFieldLabel(fieldType: string) {
  return standardLabelConfig[fieldType] ?? '';
}
